import i18next from 'i18next';
import { toast } from 'sonner';

import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class IntegrationExportIntegration {
    constructor(service) { this.service = service; }

    async _wrap(fn, fallback, notify = true) {
        try {
            const response = await fn();
            if (response?.success === true && Object.prototype.hasOwnProperty.call(response, 'data')) {
                return { success: true, data: response.data, ...(response.metadata ? { metadata: response.metadata } : {}) };
            }
            return { success: true, data: response };
        } catch (error) {
            const message = getIntegrationErrorMessage(error)
                || i18next.t('integrationToasts:exportFailed', { defaultValue: fallback });
            if (notify) toast.error(message);
            return { success: false, error: message };
        }
    }

    types() { return this._wrap(() => this.service.types(), 'Could not load export types'); }
    create(input, key) { return this._wrap(() => this.service.create(input, key), 'Could not start export'); }
    list(params) { return this._wrap(() => this.service.list(params), 'Could not load exports', false); }
    transfers(params) { return this._wrap(() => this.service.transfers(params), 'Could not load transfer history', false); }
    get(id) { return this._wrap(() => this.service.get(id), 'Could not load export', false); }
    cancel(id) { return this._wrap(() => this.service.cancel(id), 'Could not cancel export'); }
    download(id) { return this._wrap(() => this.service.download(id), 'Could not download export'); }
    exportEntity(type, format = 'json', key) { return this._wrap(() => this.service.exportEntity(type, format, key), 'Export failed'); }
}
